import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

// On rotation apply the scroll position
window.addEventListener("orientationchange", function() {
  // document.body.scrollTop = pos;
  const popup = document.querySelector('.popup')
  if (popup) popup.scrollTop = 0;
}, true);


root.render(
    <HashRouter>
      <App />
    </HashRouter>
);